import LegalPageLayout from './LegalPageLayout'
import { LEGAL_DOCS } from '../../constants/legalContent'

export default function DisclaimerPage() {
  const doc = LEGAL_DOCS.disclaimer
  return (
    <LegalPageLayout
      pageTitle={doc.pageTitle}
      effectiveDate={doc.effectiveDate}
      sections={doc.sections}
    />
  )
}

